import React, { FC } from 'react';
import useIsEnabledFeatureFlag from '../../hooks/useIsEnabledFeatureFlag';
import CommandsWithContext from './CommandsWithContext';
import CommandsPage from './v2/CommandsPage';

// Global flag, not per-company: enabling it restores the old page for everyone.
export const COMMANDS_LEGACY_PAGE_FEATURE_FLAG = 'COMMANDS_LEGACY_PAGE';

const CommandsPageSwitch: FC = () => {
  const isLegacyPageEnabled = useIsEnabledFeatureFlag(COMMANDS_LEGACY_PAGE_FEATURE_FLAG);

  return isLegacyPageEnabled ? <CommandsWithContext /> : <CommandsPage />;
};

export default CommandsPageSwitch;
